import { useCallback } from 'react';

import { useFormContext } from '#/components/Form/FormContext';
import type { StripeCreditCardAdditionalData } from '#/components/Form/Stripe/StripeCreditCardAdditionalData';

export function useDefaultGetAdditionalStripeData() {
  const { getValue } = useFormContext();

  const getAdditionalStripeData = useCallback(
    () =>
      ({
        name: getValue('name') as string,
        address_line1: getValue('addressLine1') as string,
        address_line2: getValue('addressLine2') as string,
        address_city: getValue('addressCity') as string,
        address_state: getValue('addressState') as string,
        address_zip: getValue('addressZip') as string,
        address_country: getValue('addressCountry') as string,
      }) satisfies StripeCreditCardAdditionalData,
    [getValue],
  );

  return { getAdditionalStripeData };
}
